import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  CalculationResponseInterface,
  CalculationState,
  MEASURE_UNIT,
} from "../../../entities/Calculation";
import { fetchCalculatedPricesAndVolume } from "./action";
import { CustomErrorInterface } from "../../../entities/Common";

const initialState: CalculationState = {
  isLoading: false,
  error: undefined,
  prices: {
    discountValue: 0,
    priceWithoutVatPerCup: 0,
    priceWithoutVatWithMarkup: 0,
    priceWithVatPerCup: 0,
    priceWithVatAndDiscount: 0,
    priceForOneHundredGrams: 0,
    priceForOneKilogram: 0,
    totalPrice: 0,
    totalValueWithAllProperties: 0,
    totalPriceWithoutVat: 0,
    totalValuePerNumberOfJars: 0,
    totalValueWithoutVatPerNumberOfJars: 0,
  },
  volume: {
    minVolumeOfMix: 0,
    maxVolumeOfMix: 0,
  },
  currencyShortName: "",
  countryMeasureUnit: MEASURE_UNIT.HundredGrams,
  calculationRequestCount: 0,
};

const calculationSlice = createSlice({
  name: "calculationSlice",
  initialState,
  reducers: {
    resetCalculationState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCalculatedPricesAndVolume.pending, (
        state: CalculationState,
      ) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(fetchCalculatedPricesAndVolume.fulfilled, (
        state: CalculationState,
        action: PayloadAction<CalculationResponseInterface>,
      ) => {
        state.isLoading = false;
        state.prices = action.payload.prices;
        state.volume = action.payload.volume;
        state.currencyShortName = action.payload.currencyShortName;
        state.countryMeasureUnit = action.payload.countryMeasureUnit;
        state.calculationRequestCount = state.calculationRequestCount + 1;
      })
      .addCase(fetchCalculatedPricesAndVolume.rejected, (
        state: CalculationState,
        action
      ) => {
        state.isLoading = false;
        state.error = action.payload as CustomErrorInterface;
      });
  },
});

export const { resetCalculationState } = calculationSlice.actions;

export default calculationSlice.reducer;
